// 稼働可能時間カレンダーのエンティティ
export class ShiftTable {
  // シフトID DB型(*autokey)
  public shift_table_id?: number;
  // 開始日時 DB型(TIMESTAMP)
  public start_time?: Date;
  // 終了日時 DB型(TIMESTAMP)
  public end_time?: Date;
  // 対象年 DB型(INT)
  public target_year?: number;
  // 対象月 DB型(SMALLINT)
  public target_month?: number;
  // 稼働日 DB型(TINYINT)
  public working_day?: number;
  // 先生ユーザーID DB型(*fk)
  public user_id?: string;
  // 曜日指定 DB型(*flg)
  public each_weekday?: boolean;
  // グループID DB型(*autokeyFk)
  public group_id?: number;
  // 本日のゴール予定 DB型(MEDIUMTEXT)
  public lesson_goal_plan?: string;
  // ゴール達成のポイント予定 DB型(MEDIUMTEXT)
  public lesson_point_plan?: string;
  // レッスンメモ DB型(MEDIUMTEXT)
  public lesson_memo?: string;
  static fromDB(record: { [column: string]: any; [column: number]: any }): ShiftTable {
    const entity = new ShiftTable();
    entity.shift_table_id = record['shift_table_id'];
    entity.start_time = record['start_time'];
    entity.end_time = record['end_time'];
    entity.target_year = record['target_year'];
    entity.target_month = record['target_month'];
    entity.working_day = record['working_day'];
    entity.user_id = record['user_id'];
    entity.each_weekday = record['each_weekday'];
    entity.group_id = record['group_id'];
    entity.lesson_goal_plan = record['lesson_goal_plan'];
    entity.lesson_point_plan = record['lesson_point_plan'];
    entity.lesson_memo = record['lesson_memo'];
    return entity;
  }
  static getTypeFitEntity(value: any): ShiftTable {
    const entity = new ShiftTable();
    entity.shift_table_id = value.shift_table_id;
    entity.start_time = value.start_time;
    entity.end_time = value.end_time;
    entity.target_year = value.target_year;
    entity.target_month = value.target_month;
    entity.working_day = value.working_day;
    entity.user_id = value.user_id;
    entity.each_weekday = value.each_weekday;
    entity.group_id = value.group_id;
    entity.lesson_goal_plan = value.lesson_goal_plan;
    entity.lesson_point_plan = value.lesson_point_plan;
    entity.lesson_memo = value.lesson_memo;
    return entity;
  }
}
